<!-- dersom hverken saksbeskrivelse eller generert saksreferat vises viser vi knapper for visning av disse på toppen,
 dersom noen av disse vises vises relevant knapp rett over området der tilknyttet innhold vises -->
@if (eksponerVisSaksbeskrivelseKnapp() && !viserSaksbeskrivelse() && eksponerVisGenerertSaksreferatKnapp() && !viserGenerertReferat()) {
  <div class="brytere-over-referat">
    <!-- pakker button inn i en div da matTooltip ikke vises på button dersom disabled -->
    <div [matTooltip]="visSaksbeskrivelseHjelpetekst()">
      <button mat-button color="primary" type="button" (click)="visSaksbeskrivelse()" [disabled]="!harSaksbeskrivelse()" data-testid="vis-saksbeskrivelse-knapp">
        {{ 'Vis saksbeskrivelse' | translate }}
        <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
      </button>
    </div>
    <div [matTooltip]="visGenerertSaksreferatHjelpetekst()">
      <button mat-button color="primary" type="button" (click)="visGenerertReferat()" [disabled]="!harGenerertSaksreferatInnhold()" data-testid="vis-generert-referat-knapp">
        {{ 'Vis referat fra møteopptak' | translate }}
        <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
      </button>
    </div>
  </div>
} @else if (viserSaksbeskrivelse() && eksponerVisGenerertSaksreferatKnapp() && !viserGenerertReferat()) {
  <div class="brytere-over-referat">
    <!-- pakker button inn i en div da matTooltip ikke vises på button dersom disabled -->
    <div [matTooltip]="visGenerertSaksreferatHjelpetekst()">
      <button mat-button color="primary" type="button" (click)="visGenerertReferat()" [disabled]="!harGenerertSaksreferatInnhold()" data-testid="vis-generert-referat-knapp">
        {{ 'Vis referat fra møteopptak' | translate }}
        <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
      </button>
    </div>
  </div>
}

@if (viserGenerertReferat()) {
  <div class="generert-referat-kontainer" data-testid="generert-saksreferat">
    <div class="handlinger">
      @if (harGenerertSaksreferatInnhold()) {
      <button mat-raised-button color="primary" type="button" (click)="limInnAltGenerert()" data-testid="lim-inn-generert-knapp">
        {{ 'Lim inn alt' | translate }}
      </button>
      }
      <button mat-button color="primary" type="button" (click)="skjulGenerertReferat()" data-testid="skjul-generert-referat-knapp">
        {{ 'Skjul referat fra møteopptak' | translate }}
        <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
      </button>
    </div>
    <ramme-med-tittel #generertProtokollElement>
      <!-- tittel som komponent fordi vi stiler tittelen i scss -->
      <ramme-tittel>{{ 'Referat generert fra møteopptaket' | translate }}</ramme-tittel>
      <ramme-innhold >
        @if (!harGenerertSaksreferatInnhold()) {
          <div class="ingen-oppsummering">{{ 'Møteopptaket ga ingen oppsummering av denne saken' | translate }}</div>
        } @else {
          @let generertReferat = generertSaksreferat().saksreferat!;
          <div class="generert-saksreferat">
            <!-- saniterInnhold da teksten er generert av KI, og derfor ikke sanitert av server slik lagret innhold er -->
            <html-formatert [innhold]="generertReferat.oppsummering" saniterInnhold="true" data-testid="generert-oppsummering"/>
            <button mat-button color="primary" type="button" (click)="limInnGenerertOppsummering()" data-testid="lim-inn-generert-oppsummering-knapp">
              {{ 'Lim inn i referat' | translate }}
            </button>
          </div>

          @for (generertBeslutning of generertReferat.beslutninger; track $index) {
            <div class="generert-beslutning" data-testid="generert-beslutning">
              <div class="beslutning-innhold">
                <mat-icon fontSet="lederplan-ikon-beslutning" class="mat-icon--lederplan-ikon entitetikon"/>
                <html-formatert [innhold]="generertBeslutning.beskrivelse" saniterInnhold="true"/>
                <button mat-button color="primary" type="button" (click)="registrerGenerertBeslutning(generertBeslutning)" data-testid="registrer-generert-beslutning-knapp">
                  {{ 'Registrer som beslutning' | translate }}
                </button>
              </div>

              <div class="oppgaver">
                @for (generertOppgave of generertBeslutning.oppgaver; track $index) {
                  <div class="generert-oppgave" data-testid="generert-oppgave">
                    <mat-icon fontSet="lederplan-ikon-oppgave" class="mat-icon--lederplan-ikon entitetikon"/>
                    <div class="oppgave-innhold">
                      <div class="tittel">{{ generertOppgave.tittel }}</div>
                      <html-formatert [innhold]="generertOppgave.beskrivelse" saniterInnhold="true"/>
                      <div class="detaljer">
                        @if (generertOppgave.ansvarlig != null) {
                          <span>{{ generertOppgave.ansvarlig!.navn }}</span>
                        }
                        @if (generertOppgave.frist != null) {
                          <span>{{ 'Frist {frist}'|translate: {frist: generertOppgave.frist|plaindate} }}</span>
                        }
                      </div>
                    </div>
                    <!-- pakker button inn i en div da matTooltip ikke vises på button dersom disabled -->
                    <div [matTooltip]="leggGenerertOppgaveUnderHjelpetekst()" matTooltipPosition="above">
                      <button mat-button color="primary" type="button" [matMenuTriggerFor]="beslutningsmeny" [disabled]="beslutningerOppgaveKanLeggesUnder().length == 0"
                              data-testid="registrer-generert-oppgave-knapp">
                        {{ 'Legg til under...' | translate }}
                      </button>
                    </div>
                    <mat-menu #beslutningsmeny="matMenu" class="beslutningsmeny">
                      @for (beslutningISkjema of beslutningerOppgaveKanLeggesUnder(); track beslutningISkjema) {
                        <button mat-menu-item type="button" (click)="registrerGenerertOppgave(generertOppgave, beslutningISkjema)"
                                data-testid="legg-generert-oppgave-under-beslutning-knapp">
                          <mat-icon fontSet="lederplan-ikon-beslutning" class="mat-icon--lederplan-ikon entitetikon"/>
                          {{ beslutningISkjema.value.beslutningskjema!.tittel || ('Beslutning uten tittel'|translate) }}
                        </button>
                      }
                    </mat-menu>
                  </div>
                }
              </div>

            </div>
          }
        }
      </ramme-innhold>
    </ramme-med-tittel>
  </div>
}

<!-- brytere som ligger oppå referatfeltet, gruppert i én rad når hverken saksbeskrivelse eller generert referat vises slik at de ikke legger seg oppå hverandre -->
@if (eksponerVisSaksbeskrivelseKnapp() && !viserSaksbeskrivelse() && viserGenerertReferat()) {
  <div class="brytere-over-referat">
    <!-- pakker button inn i en div da matTooltip ikke vises på button dersom disabled -->
    <div [matTooltip]="visSaksbeskrivelseHjelpetekst()">
      <button mat-button color="primary" type="button" (click)="visSaksbeskrivelse()" [disabled]="!harSaksbeskrivelse()" data-testid="vis-saksbeskrivelse-knapp">
        {{ 'Vis saksbeskrivelse' | translate }}
        <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
      </button>
    </div>
  </div>
}

@if (viserSaksbeskrivelse()) {
  <div class="saksbeskrivelse-kontainer">
    <div class="handlinger">
      <button mat-raised-button color="primary" type="button" (click)="limInnSaksbeskrivelse()" data-testid="lim-inn-saksbeskrivelse-knapp">
        {{ 'Lim inn' | translate }}
      </button>
      <button mat-button color="primary" type="button" (click)="skjulSaksbeskrivelse()" data-testid="skjul-saksbeskrivelse-knapp">
        {{ 'Skjul saksbeskrivelse' | translate }}
        <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
      </button>
    </div>
    <ramme-med-tittel>
      <!-- tittel som komponent fordi vi stiler tittelen i scss -->
      <ramme-tittel>{{ 'Saksbeskrivelse'|translate }}</ramme-tittel>
      <ramme-innhold>
        <html-formatert [innhold]="skjema().value.sak!.beskrivelse"/>
      </ramme-innhold>
    </ramme-med-tittel>
  </div>
}

<mat-form-field class="referat">
  <mat-label>{{ 'Referat'|translate }}</mat-label>
  <riktekst-redigering [skjemakontroll]="skjema().controls.referat" [gruppeId]="gruppeId()" innholdBrukesIPdf="true" data-testid="referat-felt"/>
</mat-form-field>

<moeteprotokoll-rediger-beslutninger [skjema]="skjema().controls.beslutninger" [gruppeId]="gruppeId()" #redigerBeslutningerKomponent/>

@if (avstemninger().length > 0) {
  <ramme-med-tittel [tittel]="'Avstemninger' | translate" class="avstemninger-liste">
    <ramme-innhold>
      @for (avstemning of avstemninger(); track avstemning.id; ) {
        <div class="avstemning-kontainer" data-testid="avstemning-kontainer">
          <!-- moeteLaastForRedigering=true for at ikke avstemning skal kunne redigeres i denne gui -->
          <avstemning-listevisning [avstemning]="avstemning" [avstemningsstatus]="avstemningsstatus()" [moeteLaastForRedigering]="true"/>
          @if (avstemning.erAapenForAvstemning) {
            <button mat-button color="primary" type="button" (click)="stengAvstemning(avstemning)" matTooltip="{{ 'Avstemning må stenges før denne kan registreres som beslutning' | translate }}"
                    data-testid="steng-avstemning-knapp">
              {{ 'Steng avstemning' | translate }}
            </button>
          } @else {
            <button mat-button color="primary" type="button" (click)="registrerAvstemningSomBeslutning(avstemning, redigerBeslutningerKomponent)" data-testid="registrer-avstemning-knapp" [disabled]="harTrykketOpprettAvstemning(avstemning.id)">
              {{ 'Opprett beslutning med avstemningsresultatet' | translate }}
            </button>
          }
        </div>
      }
    </ramme-innhold>
  </ramme-med-tittel>
}
